import { Lens } from "monocle-ts"

import { ParentState, State, stateKey } from "./state"

export const state = Lens.fromProp<ParentState>()(stateKey)

export const locale = Lens.fromProp<State>()("locale")

export const translations = Lens.fromProp<State>()("translations")
